import "./ErrorBoundary.css";

import React from "react";

import { apiErrorReport } from "api/errorReport";

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null, errorInfo: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		// Здесь можно отправить отчет об ошибке на сервер
		apiErrorReport.send({
			error: error?.message,
			location: window.location.pathname,
			userAgent: window.navigator.userAgent,
			userName: localStorage.getItem("userName") ?? "",
			component_stack: errorInfo.componentStack,
		});
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="error-boundary">
					<h2>Что-то пошло не так.</h2>
					<p>Пожалуйста, перезагрузите страницу или попробуйте позже.</p>
				</div>
			);
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
